import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";
import TableDefault from "../../../../components/grid/TableDefault";
import { formatDate } from "../../../../utils/formatDate";
import MaskService from "../../../../utils/mask/maskService";
import { ValueSpan } from "../ConciliacaoBancaria";
import { useContext, useEffect, useState } from "react";
import {
  Add,
  Delete,
  RemoveCircle,
  Check,
  Clear,
  Create,
  LocalOffer,
} from "@material-ui/icons/";
import DoubleInputs from "./DoubleInputs";
import ModalNewMovimentation from "./ModalNewMovimentation";
import ModalNewPaymentsReceipts from "./ModalNewPaymentsReceipts";
import Swal from "sweetalert2";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import useConciliacaoBancariaController from "../controllers/ConciliacaoBancariaController";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import ModalCategorias from "./ModalCategorias";
import BtnMenu from "./BtnMenu";
import { ConciliacaoBancariaContext } from "../contexts/ConciliacaoBancariaContext";
import { notify } from "../../../../utils/notify";

// eslint-disable-next-line
const TITLES = {
  CR: "Conta a receber",
  CP: "Conta a pagar",
  MB: "Movimentação bancária",
};

const ModalVisualization = ({
  open,
  setModalOpen,
  callAction = () => {},
  content = [],
  visualizationOnly = false,
  transactionAmount = 0,
  type,
  transactionDate,
  transactionMemo,
  extrato_transacao_id,
  conciliatedStatus = false,
  addPayments,
  setAddPayments,
  pendingsCopy,
  setPendingsCopy,
  handleChangeStatus,
}) => {
  const { cancelTitleConciliation } = useConciliacaoBancariaController();
  const {
    historicVisualization,
    needMismatchValueFullfill,
    setNeedMismatchValueFullfill,
  } = useContext(ConciliacaoBancariaContext);

  const [newArray, setNewArray] = useState([]);
  const [openModalNewMovimentation, setOpenModalNewMovimentation] =
    useState(false);
  const [openModalNewPaymentsReceipts, setOpenModalNewPaymentsReceipts] =
    useState(false);
  const [itemCategory, setItemCategory] = useState([]);
  const [itemTypeBillID, setItemTypeBillID] = useState();
  const [openModalCateogry, setOpenModalCateogry] = useState(false);
  const [needChangeStatusPending, setNeedChangeStatusPending] = useState(false);

  const handleOpenModalNewMovimentation = () => {
    setOpenModalNewMovimentation(true);
  };

  const handleOpenModalNewPaymentsReceipts = (isPayments = false) => {
    setAddPayments(isPayments);
    setOpenModalNewPaymentsReceipts(true);
  };

  const handleClose = () => {
    setPendingsCopy([]);
    setNeedMismatchValueFullfill(false);
    setNeedChangeStatusPending(false);
    setModalOpen(false);
  };

  const handleNewMovimentation = (newRow) => {
    let categoryArray = [];

    if (newRow.centro_custo) {
      categoryArray = [
        ...(newRow.centro_custo || []).map((item) => ({
          id: item.id,
          codigo: item.codigo,
          descricao: item.descricao,
          idcentronegocio: item.pivot?.idcentronegocio,
          rateio: item.pivot?.porcentagem || 0.0,
        })),
      ];
    }
    newRow.category = categoryArray;
    newRow.typeBillID = `${newRow.typeBill}_${newRow.id}`;

    setNewArray((current) => {
      return [...current, newRow];
    });
  };

  const handleNewPaymentsReceipts = (newRow) => {
    let categoryArray = [];

    if (newRow.centro_custo) {
      categoryArray = [
        ...(newRow.centro_custo || []).map((item) => ({
          id: item.id,
          codigo: item.codigo,
          descricao: item.descricao,
          idcentronegocio: item.pivot?.idcentronegocio,
          rateio: item.pivot?.porcentagem || 0.0,
        })),
      ];
    }
    newRow.category = categoryArray;
    newRow.typeBillID = `${newRow.typeBill}_${newRow.id}`;

    setNewArray((current) => {
      return [...current, newRow];
    });
  };

  const handleCancelTitleConciliation = async (row) => {
    Swal.fire({
      icon: "question",
      text: "Deseja realmente desmarcar este título?",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim",
      showConfirmButton: true,
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const callback = await cancelTitleConciliation(
          row,
          extrato_transacao_id
        );

        if (callback.success) {
          const arrayCopy = JSON.parse(JSON.stringify(newArray));
          const updatedRows = arrayCopy.filter(
            (e) => e.typeBillID !== row.typeBillID
          );

          callAction(updatedRows);
        }
      }
    });
  };

  const summedValue = newArray.reduce((acc, current) => {
    return (
      acc + parseFloat(current.valor || current.value || current.valordocto)
    );
  }, 0);

  const summedFees = newArray.reduce((acc, current) => {
    return acc + parseFloat(current.fees || 0.0);
  }, 0);

  const summedFines = newArray.reduce((acc, current) => {
    return acc + parseFloat(current.fine || 0.0);
  }, 0);

  const summedAbatement = newArray.reduce((acc, current) => {
    return acc + parseFloat(current.abatement || 0.0);
  }, 0);

  const handleSave = () => {
    const mismatchValue = parseFloat(
      (
        transactionAmount -
        (summedValue + summedFees + summedFines - summedAbatement)
      ).toFixed(2)
    );

    if (needMismatchValueFullfill) {
      if (mismatchValue) {
        return notify(
          "O valor da diferença deve estar zerado para prosseguir.",
          true,
          "warning"
        );
      } else {
        callAction(newArray);
        setNeedChangeStatusPending(true);
      }
    } else {
      callAction(newArray);
      handleClose();
    }
  };

  const lessTransaction = transactionAmount <= summedValue;

  const erpActions = [
    {
      label: "Movimentação Bancária",
      onClick: handleOpenModalNewMovimentation,
    },
    {
      label: type === "CREDIT" ? "Contas a Receber" : "Contas a Pagar",
      onClick:
        type === "CREDIT"
          ? () => handleOpenModalNewPaymentsReceipts()
          : () => handleOpenModalNewPaymentsReceipts(true),
    },
  ];

  const handleSetAbatement = (event, row, field) => {
    let valueReceived = MaskService.toMask("decimal", event.target.value, 2);

    let valueReceivedFloat = MaskService.removeMaskDecimal(valueReceived);

    const rowValue = row.value || row.valor || row.valordocto;

    const computedValue = parseFloat(row[field] || 0.0);

    let valueDifference = summedValue - transactionAmount - summedAbatement;

    if (valueReceivedFloat > rowValue) {
      valueReceivedFloat = parseFloat(rowValue).toFixed(2);
    }

    if (valueReceivedFloat > valueDifference + computedValue) {
      valueReceivedFloat = valueDifference + computedValue;
    }

    const arrayCopy = JSON.parse(JSON.stringify(newArray));

    const updatedRows = arrayCopy.map((obj) => {
      if (obj.typeBillID === row.typeBillID) {
        obj[field] = parseFloat(valueReceivedFloat).toFixed(2);
      }

      return obj;
    });

    setNewArray(updatedRows);
  };

  const handleOpenModalTitleCategory = (item) => {
    setItemCategory(item.category || []);
    setItemTypeBillID(item.typeBillID || "");
    setOpenModalCateogry(true);
  };

  const COLUMNS_MODAL_CONCILIATION = [
    ...(!visualizationOnly && !conciliatedStatus
      ? [
          {
            label: "Ações",
            id: "acoes",
            align: "center",
            format: (item) => {
              const actions = [
                {
                  name: "Deletar",
                  icon: <Delete />,
                  action: () => {
                    setNewArray((current) =>
                      current.filter((e) => e.typeBillID !== item.typeBillID)
                    );
                  },
                  disabled: historicVisualization,
                },
                {
                  name: `${
                    item.category && item.category?.length
                      ? "Editar"
                      : "Adicionar"
                  } Categorias`,
                  icon:
                    item.category && item.category?.length ? (
                      <Create />
                    ) : (
                      <Add />
                    ),
                  action: () => {
                    handleOpenModalTitleCategory(item);
                  },
                  disabled: historicVisualization,
                },
              ];

              return <SpeedDialErp actions={actions} />;
            },
          },
        ]
      : [
          {
            label: "Ações",
            id: "acoes",
            align: "center",
            format: (item) => {
              const actions = [
                {
                  name: "Desmarcar Título",
                  icon: <RemoveCircle />,
                  action: async () => {
                    handleCancelTitleConciliation(item);
                  },
                  disabled: historicVisualization || conciliatedStatus,
                },
                ...(item.category && item.category?.length
                  ? [
                      {
                        name: "Visualizar Categorias",
                        icon: <LocalOffer />,
                        action: () => {
                          handleOpenModalTitleCategory(item);
                        },
                      },
                    ]
                  : []),
              ];

              return <SpeedDialErp actions={actions} />;
            },
          },
        ]),
    {
      label: "Data",
      id: "data",
      format: (item) => {
        let getStandardDate = !!item.date;

        if (getStandardDate)
          return `${formatDate({
            date: item.date.split(" ")[0],
            separator: "/",
            format: "dd/mm/yyyy",
          })} ${item.date.split(" ")[1] ? item.date.split(" ")[1] : ""}`;
        else {
          if (item.datavencto) {
            return `${formatDate({
              date: item.datavencto.split(" ")[0],
              separator: "/",
              format: "dd/mm/yyyy",
            })} ${
              item.datavencto.split(" ")[1] ? item.datavencto.split(" ")[1] : ""
            }`;
          } else if (item.data) {
            return `${formatDate({
              date: item.data.split(" ")[0],
              separator: "/",
              format: "dd/mm/yyyy",
            })} ${item.data.split(" ")[1] ? item.data.split(" ")[1] : ""}`;
          } else {
            return "-";
          }
        }
      },
    },
    {
      label: "Nº Doc.",
      id: "numerodocto",
      format: (item) => {
        if (item.numerodocto) {
          return item.numerodocto;
        } else if (item.numberDocto) {
          return item.numberDocto;
        } else {
          return "-";
        }
      },
    },
    {
      label: "Descrição",
      id: "historico",
      format: (item) => {
        if (item.historico) {
          return item.historico;
        }

        if (item.description) {
          return item.description;
        }
      },
    },
    {
      label: "Valor",
      id: "valor",
      align: "center",
      format: (item) => {
        if (item.valor) {
          return `R$ ${MaskService.toMask("decimal", item.valor)}`;
        } else if (item.value) {
          return `R$ ${MaskService.toMask(
            "decimal",
            parseFloat(item.value).toFixed(2)
          )}`;
        } else if (item.valordocto) {
          return `R$ ${MaskService.toMask("decimal", item.valordocto)}`;
        } else {
          return "-";
        }
      },
    },
    {
      label: "Multa",
      id: "multasValues",
      format: (item) => (
        <DoubleInputs
          percentValue={item.multaPercent || "0.00"}
          monetaryValue={item.fine || "0.00"}
          setNewArray={setNewArray}
          array={newArray}
          row={item}
          percentField={"multaPercent"}
          monetaryField={"fine"}
          idrow={`${item.typeBillID}`}
          disabledInputs={
            historicVisualization ||
            item.typeBill === "movimentationsBank" ||
            visualizationOnly ||
            conciliatedStatus ||
            lessTransaction
          }
          transactionAmount={parseFloat(transactionAmount).toFixed(2)}
          summed={summedValue}
        />
      ),
    },
    {
      label: "Juros",
      id: "jurosValues",
      format: (item) => (
        <DoubleInputs
          percentValue={item.jurosPercent || "0.00"}
          monetaryValue={item.fees || "0.00"}
          setNewArray={setNewArray}
          array={newArray}
          row={item}
          percentField={"jurosPercent"}
          monetaryField={"fees"}
          idrow={`${item.typeBillID}`}
          disabledInputs={
            historicVisualization ||
            item.typeBill === "movimentationsBank" ||
            visualizationOnly ||
            conciliatedStatus ||
            lessTransaction
          }
          transactionAmount={transactionAmount}
          summed={summedValue}
        />
      ),
    },
    {
      label: "Abatimento",
      id: "abatement",
      format: (item) => (
        <div style={{ width: "110px" }}>
          <TextFieldErp
            value={MaskService.toMask(
              "decimal",
              parseFloat(item.abatement || "0.00").toFixed(2),
              2
            )}
            onChange={(event) => {
              handleSetAbatement(event, item, "abatement");
            }}
            startAdornment={
              <InputAdornment position="start">R$</InputAdornment>
            }
            InputProps={{
              style: { fontSize: "0.875rem", fontFamily: "Roboto" },
            }}
            disabled={
              historicVisualization ||
              visualizationOnly ||
              conciliatedStatus ||
              item.typeBill === "movimentationsBank" ||
              !lessTransaction
            }
          />
        </div>
      ),
    },
    {
      label: "Categorizado",
      id: "category",
      align: "center",
      format: (item) => {
        if (item.category && item.category?.length) {
          return <Check style={{ color: "green" }} />;
        } else {
          return <Clear style={{ color: "red" }} />;
        }
      },
    },
    {
      label: "Tipo",
      id: "tipo",
      format: (item) => {
        if (item.typeBill === "movimentationsBank") {
          return "MB";
        } else if (item.typeBill === "accountsPay") {
          return "CP";
        } else if (item.typeBill === "accountsReceivable") {
          return "CR";
        } else {
          return "-";
        }
      },
    },
  ];

  useEffect(() => {
    const arrayCopy = JSON.parse(
      JSON.stringify(pendingsCopy.length > 0 ? pendingsCopy : content)
    );
    arrayCopy.map((obj) => {
      if (obj.fine && !obj.multaPercent) {
        const calcPercent = parseFloat((obj.fine / obj.value) * 100).toFixed(2);

        obj.multaPercent = calcPercent;
      }

      if (obj.fees && !obj.jurosPercent) {
        const calcPercent = parseFloat((obj.fees / obj.value) * 100).toFixed(2);

        obj.jurosPercent = calcPercent;
      }

      return obj;
    });
    setNewArray(arrayCopy);
  }, [content, pendingsCopy]);

  useEffect(() => {
    if (!needChangeStatusPending) return;
    handleChangeStatus("pendente");
    handleClose();
  }, [handleChangeStatus, handleClose, needChangeStatusPending]);

  return (
    <>
      {openModalCateogry && (
        <ModalCategorias
          open={openModalCateogry}
          setModalOpen={setOpenModalCateogry}
          content={itemCategory}
          setContent={setItemCategory}
          array={newArray}
          setArray={setNewArray}
          visualizationOnly={visualizationOnly}
          contentTypeBillID={itemTypeBillID}
        />
      )}
      {openModalNewMovimentation && (
        <div>
          <ModalNewMovimentation
            open={openModalNewMovimentation}
            setModalOpen={setOpenModalNewMovimentation}
            tipo={type}
            value={
              transactionAmount -
              (summedValue + summedFees + summedFines - summedAbatement)
            }
            transactionDate={transactionDate}
            transactionMemo={transactionMemo}
            handleNewMovimentation={handleNewMovimentation}
          />
        </div>
      )}

      {openModalNewPaymentsReceipts && (
        <div>
          <ModalNewPaymentsReceipts
            open={openModalNewPaymentsReceipts}
            setModalOpen={setOpenModalNewPaymentsReceipts}
            addPayments={addPayments}
            value={
              transactionAmount -
              (summedValue + summedFees + summedFines - summedAbatement)
            }
            transactionDate={transactionDate}
            transactionMemo={transactionMemo}
            handleNewPaymentsReceipts={handleNewPaymentsReceipts}
          />
        </div>
      )}
      <Dialog open={open} fullWidth maxWidth="xl">
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          children={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              Visualização dos Itens Pendentes
              <div style={{ display: "flex", alignItems: "center" }}>
                <span className="Title" style={{ marginRight: "5px" }}>
                  Valor Total:
                </span>
                <ValueSpan
                  value={
                    type === "CREDIT"
                      ? summedValue + summedFees + summedFines - summedAbatement
                      : (summedValue +
                          summedFees +
                          summedFines -
                          summedAbatement) *
                        -1
                  }
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span className="Title" style={{ marginRight: "5px" }}>
                  Diferença:
                </span>
                <span
                  style={{ color: "#7F98C0", fontSize: 18, fontWeight: "bold" }}
                >
                  {MaskService.toMask(
                    "decimal",
                    parseFloat(
                      transactionAmount -
                        (summedValue +
                          summedFees +
                          summedFines -
                          summedAbatement)
                    ).toFixed(2)
                  )}
                </span>
              </div>
              {!visualizationOnly && !conciliatedStatus && (
                <div>
                  <BtnMenu
                    btnLabel="Novo"
                    endIcon={<Add />}
                    actions={erpActions}
                    fontSize="13px"
                    disabled={historicVisualization}
                  />
                </div>
              )}
              {visualizationOnly && <div style={{ width: "91px" }}></div>}
            </div>
          }
        />
        <DialogContent>
          <TableDefault
            values={newArray}
            columns={COLUMNS_MODAL_CONCILIATION}
          />
        </DialogContent>
        <DialogActions>
          {!visualizationOnly && !conciliatedStatus && (
            <Btn
              onClick={handleSave}
              label="Salvar"
              disabled={historicVisualization}
            />
          )}
          <Btn onClick={handleClose} bgcolor="tertiary" label="Fechar" />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalVisualization;
